<template>
  <div class="steps" :style="{ background: $color }">
    <div class="container">
      <p class="step" @click="setHomePage">
        <svg
          width="16"
          height="12"
          viewBox="0 0 16 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="home_ico"
        >
          <path
            d="M7.90667 1.43853L1.60372 7.82592V7.81824C1.13541 7.95643 0.720848 7.33458 0.812974 7.0275L7.74545 0.0950266C7.87596 -0.0278079 8.1293 -0.035485 8.2982 0.0950266C9.78562 1.58244 10.4476 2.2414 11.105 2.90484C11.9305 3.73781 12.7487 4.57786 15.1846 7.07356C15.2921 7.4651 14.8161 7.90269 14.4476 7.74147L8.14466 1.43853H7.90667Z"
            fill="white"
          />
          <path
            d="M2.70923 11.6108V7.7645L7.99112 2.3905C8.01415 2.37514 8.04486 2.36746 8.06789 2.3905L13.3498 7.67238V11.6108H2.70923Z"
            fill="white"
          />
        </svg>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0H16L24 12L16 24H0L8 12L0 0Z" :fill="$color" />
          <path d="M4 0H12L20 12L12 24H4L12 12L4 0Z" fill="#F2F2F2" />
        </svg>
      </p>
      <p
        class="step"
        v-for="(el, i) in steps"
        :key="i"
        @click="stepHandler(el.value)"
        :class="{ active: activeStep(el.value) }"
      >
        <span class="number" :style="{ color: $color }">{{i + 1}}</span>
        <span class="desktop">{{el.text}}</span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0H16L24 12L16 24H0L8 12L0 0Z" :fill="$color" />
          <path d="M4 0H12L20 12L12 24H4L12 12L4 0Z" fill="#F2F2F2" />
        </svg>
      </p>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  name: "Steps",
  computed: {
    ...mapState(["assistanceStep", "steps"]),
  },
  methods: {
    ...mapMutations(["setHomePage", "setActivePage", "setAssistanceStep"]),
    activeStep(step) {
      return this.assistanceStep === "result" &&
        (step === "home" || step === "help")
        ? true
        : step === this.assistanceStep;
    },
    stepHandler(step) {
      this.setActivePage("assistance");
      this.setAssistanceStep(step);
    },
    changeCssForPN() {
      if (document.title === "Pakiet niezawodny") {
        const steps = document.querySelector(".steps");
        steps.classList.add("steps-for-pn");
        const step = document.querySelectorAll(".step");
        step.forEach((el) => el.classList.add("step-for-pn"));
      }
    },
  },
  mounted() {
    this.changeCssForPN();
  },
  updated() {
    this.changeCssForPN();
  },
};
</script>

<style scoped lang="scss">
.steps {
  position: fixed;
  width: 100%;
  left: 0;
  top: 56px;
  @media screen and (max-width: 816px) {
    top: 66px;
  }
}
.steps-for-pn {
  @media screen and (max-width: 470px) {
    top: 86px;
  }
}
.container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.step {
  position: relative;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 14px;
  line-height: 1.15;
  font-weight: bold;
  cursor: pointer;
  padding: 0 4px;
  &:last-child {
    svg {
      display: none;
    }
  }
  .desktop {
    text-transform: uppercase;
    @media screen and (max-width: 816px) {
      display: none;
    }
  }
  &.active {
    .desktop {
      @media screen and (max-width: 816px) {
        position: fixed;
        display: block;
        white-space: nowrap;
        color: #006b4c;
        width: 100vw;
        line-height: 34px;
        text-align: center;
        left: 0;
        top: 90px;
        background-color: #fff;
      }
    }
  }
  .number {
    display: flex;
    justify-content: center;
    margin-right: 8px;
    width: 16px;
    height: 16px;
    line-height: 17px;
    border-radius: 50%;
    background: #fff;
  }
}
.step-for-pn {
  &.active {
    .desktop {
      @media screen and (max-width: 470px) {
        top: 110px;
      }
    }
  }
}
.home_ico {
  margin-right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Steps.vue